import { useEffect, useState, useCallback } from 'react';
import { buildValidation } from '../utils/FormFunctions.ts';
import Error from './FormError.tsx';

export default function InputText({ type, q, register, validate, errors, addResponse, response, firstSubmit }) {
    const [canShowError, setCanShowError] = useState<boolean>(!!response || false);
    const [blurred, setBlurred] = useState<boolean>(false);
    
    useEffect(() => {
        if (errors[q.id]?.message && (firstSubmit || blurred)) {
            setCanShowError(true);
        }
    }, [errors[q.id]?.message, firstSubmit, blurred]);

    const handleBlur = async () => {
        setBlurred(true);
        await validate();

        if (errors[q.id]?.message) {
            setCanShowError(true);
        }
    }

    const handleKeyEvent = (e) => {
        const value = e.target.value;

        addResponse({ id: q.id, value });
    };

    const hasError = errors[q.id] && canShowError;

    return (
        <div>
            <div className="mb-2.5">
                {hasError && <Error message={errors[q.id].message} />}
            </div>

            <input 
                className={`text-base autofill:bg-white ${
                    q.width ? q.width : 'w-full'
                } bg-white border  ${
                    hasError ? '!border-lava' : '!border-mizzle'
                } rounded-md px-5 !py-2.5 text-dusk placeholder:text-black/20 hover:placeholder-opacity-100 focus:outline-none`}
                type={type}
                defaultValue={response || q.default || ''} 
                placeholder={q.placeholder}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                {...register(
                    q.id,
                    {
                        ...buildValidation(q.validation),
                        onChange: handleKeyEvent,  // Handle onChange through register
                        onKeyUp: handleKeyEvent    // Handle keyUp through register
                    }
                )}
                aria-invalid={errors[q.id] ? 'true' : 'false'}
                onBlur={handleBlur}
            />
        </div>
    );
}
